import defaultSetting from '@/setting/index';
import {getToken} from '@/utils/auth';
import { Message } from 'element-ui';
import axios from 'axios';
import router from '@/router/index';
import store from '@/store/index';
// 针对401弹层特殊处理
let toastTimeOut = null;
// 创建一个 axios 实例
const service = axios.create({
  baseURL: defaultSetting.apiBaseURL,
  timeout: defaultSetting.timeout, // 请求超时时间
});

// 全局request拦截
service.interceptors.request.use(
  config => {
    config.headers['X-Token'] = getToken();
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
      config.headers['Accept'] = 'application/json';
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// 全局response拦截
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const response = error.response.data || {};
    if (error.response.status === 401) {
      if (!(!!toastTimeOut)) {
        Message({
          message: '您的登录凭证已失效，请重新登录',
          type: 'error',
          duration: defaultSetting.modalDuration
        })
        // 清空当前登录数据
        store.dispatch('user/resetToken')
        // 跳转全局登录页面
        router.push({
          path: '/login'
        })
        toastTimeOut = setTimeout(() => {
          toastTimeOut = null;
        }, 600);
      }
    } else if (error.response.status === 403) {
      Message({
        message: '您无当前操作的权限,请联系管理员',
        type: 'error',
        duration: defaultSetting.modalDuration
      })
      router.push({
        path: '/401'
      })
    }
    const msg = error.response.status === 403 || error.response.status === 401 ? 'ResponseError' : response.message;
    return Promise.reject({
      msg: msg,
      ...response
    });
  }
)

const api = {};
api.get = (url, params, options = {}) => {
  return service({
      url,
      method: 'get',
      params,
      ...options
  });
};

api.post = (url, data, options = {}) => {
  console.log({
    url,
      method: 'post',
      data,
      ...options
  })
  return service({
      url,
      method: 'post',
      data,
      ...options
  });
}

api.put = (url, data, options = {}) => {
  return service({
      url,
      method: 'put',
      data,
      ...options
  });
}

api.delete = (url, data, options = {}) => {
  return service({
      url,
      method: 'delete',
      data,
      ...options
  });
}

export default api;
